export const PATCH_CREATE_REQUESTED = 'PATCH_CREATE_REQUESTED';
export const PATCH_RENAME_REQUESTED = 'PATCH_RENAME_REQUESTED';
export const PATCH_DELETE_REQUESTED = 'PATCH_DELETE_REQUESTED';

export const SET_SELECTION = 'SET_SELECTION';
export const REMOVE_SELECTION = 'REMOVE_SELECTION';

export const TOGGLE_DEPRECATED_FILTER = 'TOGGLE_DEPRECATED_FILTER';
export const TOGGLE_UTILITY_FILTER = 'TOGGLE_UTILITY_FILTER';



// WEBPACK FOOTER //
// ../../src/projectBrowser/actionTypes.js